import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getUsersByIds } from '../api/authAdmin';

export function useUsersByIds(userIds, accessToken) {
  const ids = useMemo(() => {
    const unique = [...new Set((userIds || []).map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0))];
    unique.sort((a, b) => a - b);
    return unique;
  }, [userIds]);

  const query = useQuery({
    queryKey: ['admin-users-by-ids', ids],
    queryFn: () => getUsersByIds(ids, accessToken),
    enabled: !!accessToken && ids.length > 0,
    staleTime: 60_000,
  });

  return {
    usersById: query.data || {},
    isLoading: query.isLoading,
  };
}
